import React from "react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  ["Are your dry fruits really from Kashmir?", "Yes! Our walnuts, almonds, saffron and pine nuts are sourced directly from trusted growers in Kashmir and the Himalayas, ensuring authentic taste and premium quality."],
  ["How fresh are the products?", "We pack in small batches and vacuum-seal every order in hygienic, food-grade packaging so your dry fruits reach you fresh and full of natural flavour."],
  ["Do you deliver across India?", "Absolutely. We offer Pan-India delivery to all serviceable pincodes. Free shipping applies on orders above ₹1500."],
  ["What payment options are available?", "This is a prepaid store. You can pay online via card/UPI (Stripe), scan a UPI QR code, or place your order via WhatsApp and pay as guided. Cash on Delivery is not available."],
  ["How long does delivery take?", "Metro cities usually receive orders in 2–4 business days, while the rest of India takes 4–7 business days."],
  ["Can I track my order?", "Yes, once your order is dispatched you'll receive a tracking link on WhatsApp and email."],
  ["What if I receive a damaged product?", "Notify us within 48 hours of delivery with photos and we'll arrange a replacement or refund promptly."],
  ["Do you offer gift boxes?", "Yes! We have premium dry fruit gift boxes and hampers — perfect for festivals, weddings and corporate gifting."],
];

export default function FAQ() {
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-12">
      <div className="text-center mb-8">
        <p className="text-xs uppercase tracking-widest text-[#C2410C] font-semibold">Need Help?</p>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#1F130B] mt-1">Frequently Asked Questions</h1>
      </div>
      <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
        {FAQS.map(([q, a], i) => (
          <AccordionItem key={i} value={`item-${i}`} className="rounded-2xl bg-white border border-[#E7E0D6] px-5">
            <AccordionTrigger className="text-left font-semibold text-[#1F130B] hover:no-underline" data-testid={`faq-q-${i}`}>{q}</AccordionTrigger>
            <AccordionContent className="text-[#6B5B52] leading-relaxed">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
